// FAQ pairs displayed on /fr/acheter-bien-immobilier-pologne and used to build
// the FAQPage JSON-LD payload. Shared source so visible text and structured
// data cannot drift apart.
export const ACHETER_BIEN_FAQ = [
  {
    q: "Un Suisse a-t-il besoin d'une autorisation pour acheter en Pologne ?",
    a: "Non. Sur le plan administratif polonais, le ressortissant suisse est traité comme un ressortissant de l'Union européenne. Il achète appartement, maison ou terrain sans autorisation, partout, y compris en zone frontalière, sur le littoral et pour des terres agricoles.",
  },
  {
    q: "Un Français peut-il acheter une maison avec terrain ?",
    a: "Oui, librement. Les ressortissants de l'UE et de l'EEE achètent dans les mêmes conditions que les citoyens polonais, sans autorisation, quel que soit le type de bien et sa localisation. La dispense tient à la nationalité, quel que soit le lieu d'origine en France.",
  },
  {
    q: "Un ressortissant de pays tiers peut-il acheter un appartement ?",
    a: "Oui, sans autorisation, dès lors que l'appartement n'est pas situé en zone frontalière, et sans condition de résidence. Dans une commune frontalière ou côtière relevant de cette zone, une autorisation redevient nécessaire, même pour un appartement.",
  },
  {
    q: "Un ressortissant de pays tiers peut-il acheter un appartement à Gdańsk ou sur la côte ?",
    a: "Pas sans autorisation. Toute la côte balte, dont la Tricité (Gdańsk, Sopot et Gdynia), est en zone frontalière. Un appartement y nécessite donc une autorisation du ministère pour un ressortissant de pays tiers. Un acheteur UE ou suisse, lui, n'est pas concerné.",
  },
  {
    q: "Qu'est-ce que la zone frontalière exactement ?",
    a: "C'est une notion définie par l'article 12 de la loi de 1990 sur la protection de la frontière. Elle couvre l'intégralité du territoire des communes qui touchent une frontière terrestre ou le rivage de la mer, plus les communes voisines lorsque la largeur n'atteint pas quinze kilomètres. La liste précise figure dans un règlement de 2005, susceptible d'être modifié.",
  },
  {
    q: "Faut-il résider en Pologne pour acheter un bien ?",
    a: "Non. La propriété d'un bien ne suppose pas de résider dans le pays, et elle ne confère pas de droit de séjour. L'installation et l'enregistrement du séjour relèvent de démarches distinctes.",
  },
  {
    q: "Combien coûte l'autorisation du ministère, et combien de temps prend-elle ?",
    a: "Le droit de timbre est de 1 570 zł, remboursable en cas de refus. Le délai légal indicatif est de deux mois, mais la procédure prend souvent deux à quatre mois en pratique. L'autorisation reste ensuite valable deux ans.",
  },
  {
    q: "Quelle taxe paie-t-on à l'achat d'un bien ancien ?",
    a: "La taxe sur les actes de droit civil (PCC) au taux de 2 % de la valeur de marché, perçue par le notaire. Sur le neuf, il n'y a pas de PCC : la TVA est déjà incluse dans le prix.",
  },
  {
    q: "Un étranger peut-il acheter à crédit en Pologne ?",
    a: "Oui, un crédit immobilier (kredyt hipoteczny) est accessible aux étrangers. Lorsque l'autorisation du ministère est requise, la banque peut en demander la présentation à un moment de la procédure, à vérifier au cas par cas.",
  },
  {
    q: "Une vente conclue sans l'autorisation requise est-elle valable ?",
    a: "Non. Lorsqu'une autorisation était nécessaire et qu'elle fait défaut, l'acquisition est juridiquement nulle.",
  },
];
